import { toast } from "sonner";
import api from "./api";

// Fire-and-forget audit log of a deletion (who/what/when). Never throws.
export function logDeletion(entityType, label, reason = "") {
  api.post("/deletion-log", { entity_type: entityType, label, reason }).catch(() => {});
}

// Client-side "undo" delete: shows a toast for a few seconds and only runs the
// real delete (perform) if the user doesn't click Undo. onUndo restores the UI.
export function undoableDelete({ label = "Item", entityType = "item", perform, onUndo, reason = "", duration = 6000 }) {
  let settled = false;
  const commit = async () => {
    if (settled) return; settled = true;
    try { await perform(); logDeletion(entityType, label, reason); }
    catch (e) { toast.error("Delete failed — restoring"); onUndo && onUndo(); }
  };
  const undo = () => {
    if (settled) return; settled = true;
    onUndo && onUndo();
    toast.success(`${label} restored`);
  };
  toast(`${label} deleted`, {
    description: "This can be undone for a few seconds.",
    action: { label: "Undo", onClick: undo },
    duration,
    onAutoClose: commit,
    onDismiss: commit,
  });
}
